define('TechSpecs.View', [
  'AjaxRequestsKiller',
  'Backbone',
  'TechSpecs.Model',
  'tech_specs.tpl',
  'jQuery',
  'underscore'
], function(
  AjaxRequestsKiller,
  Backbone,
  TechSpecsModel,
  tech_specs_tpl,
  jQuery,
  _
) {
  'use strict';

  return Backbone.View.extend({

    template: tech_specs_tpl,

    initialize: function (_a) {
      var container = _a.container, pdp = _a.pdp;
      try {
        this.container = container;
        this.item = (pdp.getItemInfo() || {}).item;
        this.excludeFields = this.item.custitem_mhi_gp_ts_to_hide;
        this.model = new TechSpecsModel();
        this.techSpecs = [];
        this.getTechSpecs();
      } catch(err) { console.error(270203, err); }
    },

    getTechSpecs: function() {
      try {
        var deferred = jQuery.Deferred();
        var item = this.item || {};
        var self = this;

        this.model.fetch({
          killerId: AjaxRequestsKiller.getKillerId(),
          data: {
            itemId: item.internalid || '',
            commerceCategory: (((item.commercecategory || {}).primarypath || [])[0] || {}).name || '',
            excludeFields: this.excludeFields
          }
        }).done(function(res) {
          try {
            self.techSpecs = res;
            self.render();
            deferred.resolve();
          } catch(err) { console.error(502953, err); }
        }).fail(function(err) {
          console.error(449393, err);
        });
        return deferred;
      } catch(err) { console.error(702993, err); }
    },

    mapResults: function(res) {
      try {
        var fieldMappings = [];
        _.each(res.fields, function(field) {
          fieldMappings.push({
            label: field.fieldLabel,
            value: res.values[field.fieldId]
          });
        });
        return fieldMappings;
      } catch(err) { console.error(740014, err); }
    },

    getContext: function() {
      return {
        techSpecs: this.techSpecs
      };
    }

  });
});
